import { cssVar } from '@fabric-app/ui/theme/variables';
import { mediaMobile, mediaNotMobile, mediaTablet } from '@fabric-app/ui/constants/styled-utils';
import { ButtonIcon } from '@fabric-app/ui/components/Button';
import { motion } from 'framer-motion';
import { styled, css } from 'styled-components';
import { Flex } from '@fabric-app/ui/components/Flex';
import { framerAnimationFade } from '@fabric-app/ui/constants/framerAnimations';

const DashboardHeaderBase = styled.header.withConfig({
  displayName: "DashboardHeader__DashboardHeaderBase",
  componentId: "sc-480bb86b-0"
})([
  `flex-shrink:0;padding-top:env(safe-area-inset-top);user-select:none;border-bottom:1px solid transparent;`,
  ` min-height:60px;`,
  `{min-height:64px;`,
  `}`
], (p) => !p.transparent && css([
  `background-color:`,
  `;`,
  `{background-color:`,
  `;}border-bottom:1px solid `,
  `;`
], cssVar["color-bg-secondary"], mediaMobile, cssVar["color-bg-primary"], cssVar["color-border-primary"]), mediaNotMobile, (p) => p.mobileOnly && "display: none;");
const DashboardHeaderBackTitleContainer = styled(Flex).attrs((props) => {
  return {
    alignItems: "center",
    ...props
  };
}).withConfig({
  displayName: "DashboardHeader__DashboardHeaderBackTitleContainer",
  componentId: "sc-480bb86b-1"
})([
  `color:`,
  `;`,
  ` min-height:3rem;`,
  `{min-height:2.5rem;}min-width:0;`
], cssVar["color-text-primary"], (p) => !p.gap && css([
  `gap:0.5rem;`
]), mediaMobile);
const DashboardHeaderBody = styled(motion.div).attrs({
  ...framerAnimationFade
}).withConfig({
  displayName: "DashboardHeader__DashboardHeaderBody",
  componentId: "sc-480bb86b-2"
})([
  `display:flex;align-items:center;justify-content:space-between;min-height:64px;gap:1rem;padding:0.25rem 0.75rem;`,
  `{padding:0.75rem;min-height:60px;}& > *{flex-grow:1;}overflow:hidden;& + &{margin-top:-12px;min-height:0;}`
], mediaTablet);
const DashboardHeaderIcon = styled.div.withConfig({
  displayName: "DashboardHeader__DashboardHeaderIcon",
  componentId: "sc-480bb86b-3"
})([
  `width:20px;height:20px;display:flex;align-items:center;justify-content:center;`
]);
const DashboardHeaderActions = styled(Flex).attrs((props) => {
  return {
    alignItems: "center",
    ...props
  };
}).withConfig({
  displayName: "DashboardHeader__DashboardHeaderActions",
  componentId: "sc-480bb86b-4"
})([
  `gap:0.75rem;`,
  `{gap:0.5rem;}align-items:center;justify-self:flex-end;min-height:3rem;`,
  `{min-height:2.5rem;}justify-content:flex-end;`
], mediaMobile, mediaMobile);
const DashboardHeaderTag = styled.h1.withConfig({
  displayName: "DashboardHeader__DashboardHeaderTag",
  componentId: "sc-480bb86b-5"
})([
  `height:32px;display:flex;align-items:center;gap:0.375rem;padding:0 0.5rem;border-radius:8px;min-width:fit-content;background:`,
  `;color:#111;font-size:18px;font-weight:500;line-height:32px;letter-spacing:-0.02em;.tag_size{width:24px;height:24px;display:flex;flex-direction:column;justify-content:center;align-items:center;}`
], cssVar["color-app-primary-cmp"]);
const Separator = styled.div.attrs((p) => {
  return {
    ...p,
    children: "/"
  };
}).withConfig({
  displayName: "DashboardHeader__Separator",
  componentId: "sc-480bb86b-6"
})([
  `font-weight:500;font-size:18px;line-height:32px;color:`,
  `;opacity:0.5;`
], cssVar["color-text-tertiary"]);
const UpTreeButton = styled(ButtonIcon).attrs((p) => {
  return {
    ...p,
    children: "..."
  };
}).withConfig({
  displayName: "DashboardHeader__UpTreeButton",
  componentId: "sc-480bb86b-7"
})([
  `font-size:1rem;`
]);
const DashboardHeader = Object.assign(DashboardHeaderBase, {
  Body: DashboardHeaderBody,
  Left: DashboardHeaderBackTitleContainer,
  Right: DashboardHeaderActions,
  Tag: DashboardHeaderTag,
  Icon: DashboardHeaderIcon,
  UpTreeButton,
  Separator
});
const DashboardSubheaderRoot = styled(motion.div).attrs((props) => {
  return {
    ...framerAnimationFade,
    transition: {
      delay: 0,
      duration: 0.1
    },
    ...props
  };
}).withConfig({
  displayName: "DashboardHeader__DashboardSubheaderRoot",
  componentId: "sc-480bb86b-8"
})([
  `flex-shrink:0;background:`,
  `;border-bottom:1px solid `,
  `;`
], cssVar["color-bg-primary"], cssVar["color-border-primary"]);
const DashboardSubheaderBody = styled(Flex).attrs((props) => {
  return {
    alignItems: "center",
    gap: "elementsContainer",
    ...props
  };
}).withConfig({
  displayName: "DashboardHeader__DashboardSubheaderBody",
  componentId: "sc-480bb86b-9"
})([
  `padding:0.25rem 0.75rem;min-height:64px;`,
  `{padding:0.75rem;}`
], mediaMobile);
const DashboardSubheader = Object.assign(DashboardSubheaderRoot, {
  Body: DashboardSubheaderBody
});

export { DashboardHeader, DashboardSubheader };
//# sourceMappingURL=DashboardHeader.js.map
